import jsKit from './jsKit';

const disableBokMode = async (event) => {
  event.preventDefault();

  const trigger = event.delegateTarget || event.currentTarget;
  trigger.disabled = true;

  const data = await jsKit.requestUrl('/main/disableBokMode', 'json');
  if (!data?.validated) {
    trigger.disabled = false;
    return;
  }

  document.getElementById('bok_mode_info')?.remove();

  if (data.redirect) {
    window.location.assign(data.redirect);
  }
};

export const headerSpecialFunctionsEvents = [
  ['jsDisableBokMode', disableBokMode],
];
